import { connect } from 'react-redux'
import AddWorksDialog from './add-works-dialog'
import { errorHandler } from 'pobble-components/dist/error-handler'
import {
  addWorkToAssessmentFile,
  fetchStudentWorks,
  closeAddWorksDialog
} from '../../../stores/works/works.actions'
import {
  getAddWorksDialog,
  getWorksResult,
  getWorksAssessmentFileStudent,
  getWorksAssessmentFileId
} from '../../../stores/works/works.selectors'

const mapStateToProps = state => {
  const dialog = getAddWorksDialog(state)
  const student = getWorksAssessmentFileStudent(state)
  const assessmentFileId = getWorksAssessmentFileId(state)
  const currentWorks = getWorksResult(state)
  return {
    isOpen: dialog.opened,
    studentId: student && student.account.id,
    studentName: student && student.account && student.account.first_name,
    assessmentFileId: assessmentFileId,
    currentWorks: currentWorks,
    pending: false
  }
}

const mapDispatchToProps = dispatch => ({ dispatch })

const mergeProps = (stateProps, { dispatch }, ownProps) => ({
  ...stateProps,
  ...ownProps,
  onClose: () => dispatch(closeAddWorksDialog()),
  onMount: id => dispatch(fetchStudentWorks(id)).catch(errorHandler),
  onAdd: (id, assessmentFileId) => {
    return dispatch(addWorkToAssessmentFile(id, assessmentFileId)).catch(
      errorHandler
    )
  }
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(AddWorksDialog)
